import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative flex items-center justify-center min-h-full p-4"
}

import { ref } from "vue";
import Image from "@/views/blocks/shared/section/media/image/Image.vue";

interface LightboxImage {
    src: string;
    alt: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LightboxDialog',
  props: {
    selectedImage: {}
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



const emit = __emit;

const lightboxDialog = ref<HTMLDialogElement | null>(null);

// Watch for selectedImage changes to open/close dialog
const openLightbox = () => {
    lightboxDialog.value?.showModal();
};

const closeLightbox = () => {
    emit("close");
    lightboxDialog.value?.close();
};

// Expose methods for parent component
__expose({
    openLightbox,
    closeLightbox,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    ref_key: "lightboxDialog",
    ref: lightboxDialog,
    class: "backdrop:bg-black backdrop:bg-opacity-75 bg-transparent p-0 max-w-none max-h-none w-full h-full",
    onClick: _withModifiers(closeLightbox, ["self"])
  }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300",
      "enter-from-class": "opacity-0 scale-95",
      "enter-to-class": "opacity-100 scale-100",
      "leave-active-class": "transition-all duration-300",
      "leave-from-class": "opacity-100 scale-100",
      "leave-to-class": "opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                onClick: closeLightbox,
                class: "absolute top-4 right-4 z-10 bg-black bg-opacity-50 hover:bg-opacity-75 text-white rounded-full p-3 transition-all duration-200",
                "aria-label": "Close lightbox"
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("svg", {
                  class: "w-6 h-6",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ])),
              _createVNode(Image, {
                src: _ctx.selectedImage.src,
                alt: _ctx.selectedImage.alt,
                class: "max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-2xl"
              }, null, 8, ["src", "alt"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})